<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="交易对">
              <el-select clearable v-model="where.rate_pair_name" placeholder="请选择" class="ele-block">
                <el-option v-for="item in tradingPairList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon"
            :loading="clearing" @click="clearAll"
            v-if="permission.includes('sys:transmodel:edit')">初始化</el-button>
          <el-button size="small" type="success" icon="el-icon-plus" class="ele-btn-icon"
            @click="showPairFill = true"
            v-if="permission.includes('sys:transmodel:add')">补齐交易对</el-button>
          <el-button size="small" type="info" icon="el-icon-document" class="ele-btn-icon"
            @click="showOkxAds = true"
            v-if="permission.includes('sys:transmodel:edit')">欧易广告</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:transmodel:delete')">删除</el-button>
        </template>

        <template slot="float_label" slot-scope="{ row }">
          <dict-tag v-if="row.float_type" dict-code="rate_float_type" :value="row.float_type" />
        </template>

        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:transmodel:edit')">编辑</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此模型吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:transmodel:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>

    <transmodel-edit :data="current" :visible.sync="showEdit" @done="onDone" />
    <okx-ad-dialog :visible.sync="showOkxAds" @done="onDone" />
    <pair-fill-dialog :visible.sync="showPairFill" @done="onDone" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TransmodelEdit from './transmodel-edit';
import OkxAdDialog from './okx-ad-dialog';
import PairFillDialog from './pair-fill-dialog';

export default {
  name: 'Transmodel',
  components: { TransmodelEdit, OkxAdDialog, PairFillDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/transmodel/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'rate_pair_name', label: '交易对', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'float_label', label: '浮动方向', minWidth: 90, align: 'center', slot: 'float_label' },
        { prop: 'market_rate', label: '市场汇率', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'operate_rate', label: '运营汇率', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'settle_rate', label: '结算汇率', minWidth: 110, align: 'center', showOverflowTooltip: true },
        { prop: 'reverse_pair_name', label: '反向交易对', minWidth: 130, align: 'center', showOverflowTooltip: true },
        { prop: 'reverse_rate', label: '反向汇率', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { columnKey: 'action', label: '操作', width: 150, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: { rate_pair_name: '' },
      tradingPairList: [],
      selection: [],
      current: null,
      showEdit: false,
      showOkxAds: false,
      showPairFill: false,
      clearing: false
    };
  },
  mounted() {
    this.getTradingPairList();
  },
  methods: {
    onDone() {
      this.getTradingPairList();
      this.reload();
    },
    getTradingPairList() {
      this.$http.get('/transmodel/getTradingPairs').then((res) => {
        if (res.data.code === 0) {
          this.tradingPairList = res.data.data || [];
        }
      }).catch((e) => this.$message.error(e.message));
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = { rate_pair_name: '' };
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    clearAll() {
      this.$confirm('初始化将清空交易模型全部数据（不会自动生成交易对），是否继续？', '初始化', { type: 'warning' })
        .then(() => {
          this.clearing = true;
          this.$http.post('/transmodel/clearAll').then((res) => {
            this.clearing = false;
            if (res.data.code === 0) {
              this.$message.success(`${res.data.msg}（已删除 ${(res.data.data || {}).cleared || 0} 条）`);
              this.onDone();
            } else {
              this.$message.error(res.data.msg || '初始化失败');
            }
          }).catch((e) => {
            this.clearing = false;
            this.$message.error(e.message);
          });
        })
        .catch(() => {});
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/transmodel/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.onDone();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的模型吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/transmodel/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.onDone();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>
